module.exports = __webpack_public_path__ + "img/footer-bg-2.f7468145.png";